import i18next from "i18next"

const filterOptions = [
  {
    name: "status",
    type: "select",
    get options() {
      return [
        { label: i18next.t("All"), value: 2 },
        { label: i18next.t("Active"), value: 1 },
        { label: i18next.t("Deactive"), value: 0 },
      ]
    },
    get placeholder() {
      return i18next.t("All")
    },
  },
  {
    name: "sortOrder",
    type: "select",
    get options() {
      return [
        { label: i18next.t("Ascending"), value: 1 },
        { label: i18next.t("Descending"), value: 2 },
      ]
    },
    get placeholder() {
      return i18next.t("Ascending")
    },
  },
]

const hoursOptions = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
  { value: 7, label: "7" },
  { value: 8, label: "8" },
]

export { filterOptions, hoursOptions }
